var module = angular.module('octopusApp.library');

import React from 'react';
import {Table, Button} from 'react-bootstrap';
import StepTemplateLogo from 'step_template_logo';

Templates.propTypes =  {
    name: React.PropTypes.string.isRequired,
    enabled: React.PropTypes.bool.isRequired,
    actionName: React.PropTypes.string.isRequired,
    actionUrl: React.PropTypes.string.isRequired,
    templates: React.PropTypes.array.isRequired,
    resolveLink: React.PropTypes.func.isRequired,
    emptyState: React.PropTypes.element.isRequired,
    allowRunningScriptTemplates: React.PropTypes.bool,
    actions: React.PropTypes.element.isRequired,
    promptWhenEmpty: React.PropTypes.element.isRequired
};

function Templates (props) {
    var hasTemplates = props.templates != null && props.templates.length > 0;

    let templateInstalled = _.find(props.templates, function(template) { return template.hasOwnProperty('stepInstalledSuccessfully'); });
    var stepInstallSuccessfully = hasTemplates && templateInstalled != null;

    return <div>
        <h4>{props.name}{props.enabled && props.actions}</h4>

        <div className="margin-top-15">

            { props.enabled || <div className="alert alert-info">{props.emptyState}</div>}
            { stepInstallSuccessfully && <div className="alert alert-success"><a className="alert-link" href={"#/library/steptemplates/" + templateInstalled.Id}>{templateInstalled.Name}</a> was installed successfully</div>}

            {hasTemplates ? (
                <Table striped condensed>
                    <tbody>
                    {props.templates.map(template => {
                        return <tr key={template.Id}>
                            <td>
                                <div className="pull-left"><StepTemplateLogo class="logo" size="x-small" url={template.Links.Logo} resolveLink={props.resolveLink} /></div>
                                <div className="col-md-10 col-sm-9 col-xs-10 cell-height-sm"><a href={"#/library/steptemplates/" + template.Id}>{template.Name}</a></div>
                            </td>
                            <td>
                                {(props.allowRunningScriptTemplates && template.Type === 'Octopus.Script') && <Button className="pull-right" bsStyle="info" href={'#/library/steptemplates/' + template.Id +'/run'}>Run</Button>}
                            </td>
                        </tr>;
                    })}
                    </tbody>
                </Table>
            ) : (
            props.enabled && <div className="alert alert-info">{props.promptWhenEmpty}</div>
            )}
        </div>
    </div>;
}

InstalledStepTemplates.propTypes = {
    userInstalledTemplates: React.PropTypes.array.isRequired,
    addCustomStepTemplateUrl: React.PropTypes.string.isRequired,
    communityStepTemplatesEnabled: React.PropTypes.bool.isRequired,
    communityInstalledTemplates: React.PropTypes.array.isRequired,
    installCommunityStepTemplateUrl: React.PropTypes.string.isRequired,
    resolveLink: React.PropTypes.func.isRequired,
    import: React.PropTypes.func.isRequired
};

function InstalledStepTemplates (props) {

    let userInstalledTemplates = props.userInstalledTemplates != null ? props.userInstalledTemplates : [];
    let communityInstalledTemplates = props.communityInstalledTemplates != null ? props.communityInstalledTemplates : [];

    return <div>
        <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
                <h3>Step templates</h3>
                <p>
                    Step templates are pre-configured steps that can be reused in multiple projects. If the Community library is disabled, visit the <a href="http://g.octopushq.com/CommunityLibrary" target="_blank">community library website</a> to browse and import step templates manually.
                </p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6">
                <Templates name="Custom step templates"
                           enabled={true}
                           actionName="Add"
                           actions={<div className="pull-right">
                               <a className="btn btn-link" onClick={props.import}>Import</a>
                               <a className="btn btn-success" href={props.addCustomStepTemplateUrl}>Add</a>
                           </div>}
                           promptWhenEmpty={<a className="alert-link" href={props.addCustomStepTemplateUrl}>Add your first custom step template.</a>}
                           actionUrl={props.addCustomStepTemplateUrl}
                           templates={userInstalledTemplates}
                           resolveLink={props.resolveLink}
                           allowRunningScriptTemplates={true}
                           emptyState={<span>Custom step templates will be listed here</span>}/>
            </div>

            <div className="col-sm-6 col-md-6 col-lg-6">
                <Templates name="Community step templates"
                           enabled={props.communityStepTemplatesEnabled}
                           actions={<a className="btn btn-success pull-right" href={props.installCommunityStepTemplateUrl}>Install</a>}
                           promptWhenEmpty={<a className="alert-link" href={props.installCommunityStepTemplateUrl}>Install your first community step template.</a>}
                           actionName="Install"
                           actionUrl={props.installCommunityStepTemplateUrl}
                           templates={communityInstalledTemplates}
                           resolveLink={props.resolveLink}
                           allowRunningScriptTemplates={false}
                           emptyState={<span>Community library integration is disabled.  If you want to take advantage of hundreds great templates developed by the members of our community then please <a className='alert-link' href='#/configuration/features'>enable the integration feature.</a></span>}/>
            </div>

        </div>
    </div>;
}

module.directive('installedStepTemplates', function (reactDirective) {
    return reactDirective(InstalledStepTemplates);
});



// WEBPACK FOOTER //
// ./app/areas/library/steps/views/step_templates_installed.jsx